// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Unteraufgabe, UnteraufgabeDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateUnteraufgabe(): (
  aufgabeId: string,
  requestBody: UnteraufgabeDaten
) => Promise<Unteraufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, requestBody) =>
      (await getAPI()).unteraufgaben.createUnteraufgabe({
        aufgabeId,
        requestBody,
      }),
    [getAPI]
  );
}
